var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModuleAdvanced(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-ab9a988f-3e93-42e8-a9eb-185845430fb6",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.51,
    height: 11.95,
    viewBox: "0 0 15.51 11.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-9dc844dc-d4d5-40e6-922d-d2056e90ff76",
    "data-name": "Object"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.3,2.47H5.43c-.12,0-.21-.09-.21-.21s.09-.21.21-.21h9.87c.12,0,.21.09.21.21s-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9,2.47H.21c-.12,0-.21-.09-.21-.21s.09-.21.21-.21h3.69c.12,0,.21.09.21.21s-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3,6.27h-3.87c-.12,0-.21-.09-.21-.21s.09-.21.21-.21h3.87c.12,0,.21.09.21.21s-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.36,6.27H.21c-.12,0-.21-.09-.21-.21s.09-.21.21-.21h10.15c.12,0,.21.09.21.21s-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3,10.08H4.95c-.12,0-.21-.09-.21-.21s.09-.21.21-.21h10.35c.12,0,.21.09.21.21s-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9,10.08H.21c-.12,0-.21-.09-.21-.21s.09-.21.21-.21h3.69c.12,0,.21.09.21.21s-.09.21-.21.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.9,4.16c-.12,0-.21-.09-.21-.21V.21c0-.12.09-.21.21-.21s.21.09.21.21v3.74c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9,11.95c-.12,0-.21-.09-.21-.21v-3.74c0-.12.09-.21.21-.21s.21.09.21.21v3.74c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.43,7.95c-.12,0-.21-.09-.21-.21v-3.79c0-.12.09-.21.21-.21s.21.09.21.21v3.79c0,.12-.09.21-.21.21Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleAdvanced);
export default __webpack_public_path__ + "static/media/icon_module_advanced.3a1ac7e849ff10fb9b3790657c55adbb.svg";
export { ForwardRef as ReactComponent };